@for (env of envelopes; track env.id) {
  <div class="notes lexgo-item">
    <div class="notes-item">
      <div class="lexgo-item__header">
        <div class="lexgo-item__title">
          <strong>{{ env.name | uppercase }}</strong>
          <div class="lexgo-item__filename">
            {{ env.attachmentName | uppercase }}
            @if (env.pageCount) {
              <span class="text-muted small"> · {{ env.pageCount }} pág.</span>
            }
          </div>
        </div>

        <div class="dropdown lexgo-item__menu">
          <div ngbDropdown [autoClose]="true" class="d-inline-block" container="body">
            <i
              ngbDropdownToggle
              class="dropdown-toggle fas fa-ellipsis-v lexgo-item__menu-toggle"
              [class.disabled]="isBusy(env.id)"
              (click)="$event.stopPropagation()"
            ></i>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
              @if (canRemind(env)) {
                <button
                  type="button"
                  class="dropdown-item"
                  [disabled]="isBusy(env.id)"
                  (click)="sendReminder(env)"
                >
                  <i class="fas fa-paper-plane mr-2"></i>
                  Enviar recordatorio
                </button>
              }
              <button type="button" class="dropdown-item" (click)="viewProgress(env)">
                <i class="fas fa-chart-bar mr-2"></i>
                Ver progreso
              </button>
              <button
                type="button"
                class="dropdown-item"
                [disabled]="!canEvidence(env) || isBusy(env.id)"
                (click)="openEvidence(env)"
              >
                <i class="fas fa-file-alt mr-2"></i>
                Hoja de evidencia
              </button>
              @if (canSignAny(env)) {
                <button type="button" class="dropdown-item" (click)="openSign(env)">
                  <i class="fas fa-pen mr-2"></i>
                  Firmar en Flow
                </button>
              }
              @if (env.documentUrl) {
                <a
                  class="dropdown-item"
                  target="_blank"
                  [href]="env.documentUrl"
                  rel="noopener"
                >
                  <i class="fas fa-download mr-2"></i>
                  PDF original / documento
                </a>
              }
              @if (canVoid(env)) {
                <div class="dropdown-divider"></div>
                <button
                  type="button"
                  class="dropdown-item text-danger"
                  [disabled]="isBusy(env.id)"
                  (click)="voidEnvelope(env)"
                >
                  <i class="fas fa-ban mr-2"></i>
                  Anular firma
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="mt-2 lexgo-status-row">
        <span class="badge" [ngClass]="statusClass(env.status)">
          {{ statusLabel(env.status) }}
        </span>
        <span class="text-muted small ml-2">
          {{ signedCount(env) }}/{{ recipientsOf(env).length }} firmas
        </span>
      </div>

      <div class="text-muted small mt-1">
        @if (env.createdBy) {
          <span>Creado por: {{ env.createdBy }}</span>
        }
        @if (env.createdAt) {
          <span class="ml-2">{{ env.createdAt | date: 'medium' }}</span>
        }
      </div>

      @if (recipientsOf(env).length) {
        <div class="notes-footer align-items-end mt-2">
          <p class="fields-title">
            Firmantes ({{ signedCount(env) }}/{{ recipientsOf(env).length }}):
          </p>
          <ul class="fileds-list">
            @for (r of recipientsOf(env); track r.email) {
              <li>
                {{ r.name }}
                <br />
                @if (r.email) {
                  <span>Email: {{ r.email }}</span>
                  <br />
                }
                <span class="text-muted small">Estado: {{ recipientStatusLabel(r.status) }}</span>
                <i
                  class="status-icon far ml-2"
                  [class.fa-edit]="r.status === 'SIGNED'"
                  [class.green]="r.status === 'SIGNED'"
                  [class.fa-clock]="r.status !== 'SIGNED' && r.status !== 'REJECTED'"
                  [class.orange]="r.status !== 'SIGNED' && r.status !== 'REJECTED'"
                  [class.fa-times]="r.status === 'REJECTED'"
                  style="font-size: 1.4em; vertical-align: middle;"
                ></i>
                @if (canSign(r)) {
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-0 ml-2 align-baseline"
                    (click)="openSign(env, r)"
                  >
                    Firmar
                  </button>
                }
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
}
